module.exports = __webpack_public_path__ + "static/Kratos-241d8d2c1c52b74a88fc093d9c752859.jpg";